import React from 'react';
import { SnackbarProvider } from 'notistack';
import StyledSnackbar from './StyledSnackbar';

const snackbarComponents = {
  default: StyledSnackbar,
  success: StyledSnackbar,
  error: StyledSnackbar,
  warning: StyledSnackbar,
  info: StyledSnackbar,
};

export default function AppSnackbarProvider({ children }) {
  return (
    <SnackbarProvider
      maxSnack={4}
      preventDuplicate
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      autoHideDuration={4000}
      Components={snackbarComponents}
    >
      {children}
    </SnackbarProvider>
  );
}
